import { Navigate, Route, Routes } from 'react-router-dom'
import AllPlaylists from '../../features/music/playlists/AllPlaylists'
import EditPlaylist from '../../features/music/playlists/EditPlaylist'
import NewPlaylist from '../../features/music/playlists/NewPlaylist'
import AllTracks from '../../features/music/songs/AllTracks'
import TracksLayout from '../../features/music/songs/TracksLayout'
import UploadTracks from '../../features/music/songs/UploadTracks'
import MoodsLayout from '../../features/music/moods/MoodsLayout'
import PlaylistsLayout from '../../features/music/playlists/PlaylistsLayout'

import StylesLayout from '../../features/music/styles/StylesLayout'
import BusinessesLayout from '../../features/music/businesses/BusinessesLayout'
import DaytimesLayout from '../../features/music/daytimes/DaytimesLayout'
import EditFolder from '../../components/PlaylistFolder/EditFolder'
import AllFolders from '../../components/PlaylistFolder/AllFolders'
import NewFolder from '../../components/PlaylistFolder/NewFolder'
import {
  attemptCreateMood,
  attemptDeleteMood,
  attemptEditMood,
  attemptGetMood,
  attemptGetMoodsList,
} from '../redux/moodsSlice'
import {
  attemptCreateBusiness,
  attemptDeleteBusiness,
  attemptEditBusiness,
  attemptGetBusiness,
  attemptGetBusinessesList,
} from '../redux/businessesSlice'
import { useAppSelector } from '../redux/store'
import {
  attemptCreateStyle,
  attemptDeleteStyle,
  attemptEditStyle,
  attemptGetStyle,
  attemptGetStylesList,
} from '../redux/stylesSlice'
import {
  attemptCreateDaytime,
  attemptDeleteDaytime,
  attemptEditDaytime,
  attemptGetDaytime,
  attemptGetDaytimesList,
} from '../redux/daytimesSlice'

export default function MusicRoutes() {
  return (
    <Routes>
      <Route path="songs/*" element={<TracksLayout />} />
      <Route path="playlists/*" element={<PlaylistsLayout />} />
      <Route path="playlists/playlist-edit/:id" element={<EditPlaylist />} />
      <Route path="styles/*" element={<StylesLayout />} />
      <Route path="styles/style-edit/:id" element={
        <EditFolder
          successPath="/music/styles/all"
          attemptEdit={attemptEditStyle}
          attemptGet={attemptGetStyle}
          folder='style'
          uploadedDestination={'styles'}
        />

      } />
      <Route path="moods/*" element={<MoodsLayout />} />
      <Route
        path="moods/mood-edit/:id"
        element={
          <EditFolder
            successPath="/music/moods/all"
            attemptEdit={attemptEditMood}
            attemptGet={attemptGetMood}
            folder='mood'
            uploadedDestination={'moods'}
          />
        }
      />
      <Route path="businesses/*" element={<BusinessesLayout />} />
      <Route
        path="businesses/business-edit/:id"
        element={
          <EditFolder
            successPath="/music/businesses/all"
            attemptEdit={attemptEditBusiness}
            attemptGet={attemptGetBusiness}
            folder='business'
            uploadedDestination={'businesses'}
          />
        }
      />
      <Route path="daytimes/*" element={<DaytimesLayout />} />
      <Route path="daytimes/daytime-edit/:id" element={
        <EditFolder
        successPath="/music/daytimes/all"
        attemptEdit={attemptEditDaytime}
        attemptGet={attemptGetDaytime}
        folder='daytime'
        uploadedDestination={'daytimes'}
      />
      } />
    </Routes>
  )
}

export function TracksRouter() {
  return (
    <Routes>
      <Route path="*" element={<Navigate to={'/music/songs/all'} />} />
      <Route path="all" element={<AllTracks />} />
      <Route path="upload" element={<UploadTracks />} />
    </Routes>
  )
}

export function PlaylistsRouter() {
  return (
    <Routes>
      <Route path="*" element={<Navigate to={'/music/playlists/all'} />} />
      <Route path="all" element={<AllPlaylists />} />
      <Route path="new" element={<NewPlaylist />} />
    </Routes>
  )
}

export function StylesRouter() {
  const { styles } = useAppSelector((state) => state.styles)

  return (
    <Routes>
      <Route path="*" element={<Navigate to={'/music/styles/all'} />} />
      <Route
        path="all"
        element={
          <AllFolders
            editPath="/music/styles/style-edit"
            uploadedDestination="styles"
            attemptGetList={attemptGetStylesList}
            attemptDelete={attemptDeleteStyle}
            folder={styles}
          />
        }
      />
      <Route
        path="new"
        element={
          <NewFolder
            successPath="/music/styles/all"
            attempt={attemptCreateStyle}
            uploadedDestination={'styles'}
          />
        }
      />
    </Routes>
  )
}

export function BusinessesRouter() {
  const { businesses } = useAppSelector((state) => state.businesses)

  return (
    <Routes>
      <Route path="*" element={<Navigate to={'/music/businesses/all'} />} />
      <Route
        path="all"
        element={
          <AllFolders
            editPath="/music/businesses/business-edit"
            uploadedDestination="businesses"
            attemptGetList={attemptGetBusinessesList}
            attemptDelete={attemptDeleteBusiness}
            folder={businesses}
          />
        }
      />
      <Route
        path="new"
        element={
          <NewFolder
            successPath="/music/businesses/all"
            attempt={attemptCreateBusiness}
            uploadedDestination={'businesses'}
          />
        }
      />
    </Routes>
  )
}

export function DaytimesRouter() {
  const { daytimes } = useAppSelector((state) => state.daytimes)

  return (
    <Routes>
      <Route path="*" element={<Navigate to={'/music/daytimes/all'} />} />
      <Route
        path="all"
        element={
          <AllFolders
            editPath="/music/daytimes/daytime-edit"
            uploadedDestination="daytimes"
            attemptGetList={attemptGetDaytimesList}
            attemptDelete={attemptDeleteDaytime}
            folder={daytimes}
          />
        }
      />
      <Route
        path="new"
        element={
          <NewFolder
            successPath="/music/daytimes/all"
            attempt={attemptCreateDaytime}
            uploadedDestination={'daytimes'}
          />
        }
      />
    </Routes>
  )
}

export function MoodsRouter() {
  const { moods } = useAppSelector((state) => state.moods)

  return (
    <Routes>
      <Route path="*" element={<Navigate to={'/music/moods/all'} />} />
      <Route
        path="all"
        element={
          <AllFolders
            editPath="/music/moods/mood-edit"
            uploadedDestination="moods"
            attemptGetList={attemptGetMoodsList}
            attemptDelete={attemptDeleteMood}
            folder={moods}
          />
        }
      />
      <Route
        path="new"
        element={
          <NewFolder
            successPath="/music/moods/all"
            attempt={attemptCreateMood}
            uploadedDestination={'moods'}
          />
        }
      />
    </Routes>
  )
}
